import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/Service.module.css'; 

const Service = ({ title, icon, description }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.card}>
      <img src={icon} alt={title} />
      <h1 className={styles['card-title']}>
        {title}
      </h1>
      <p className={styles['card-description']}>
        {description}
      </p>
      <div style={{ marginTop: 'auto' }}>
        <button
          onClick={() => navigate(`/services/${title}`)}
          className={styles.button}
        >
          Voir plus
        </button>
      </div>
    </div>
  );
};

export default Service;
